export default __webpack_public_path__ + "static/media/carlos-barbero-3.6f253218.webp";